export default __webpack_public_path__ + "static/media/new poki.7fb5b619.png";